<template>
  <LinkPopover v-if="button.mark === 'link'" :editor="editor" :disabled="disabled" />
  <button
    v-else
    v-tippy="{ content: button.name }"
    type="button"
    :aria-label="button.name"
    :disabled="disabled"
    :aria-pressed="button.mark ? active : undefined"
    :class="[
      'rounded-lg h-7 flex items-center justify-center transition',
      active ? 'bg-primary-900 text-white': ' text-gray-700 dark:text-white/70 bg-transparent',
      hasIcon ? 'w-7' : 'px-2',
      disabled ? 'cursor-not-allowed opacity-50' : 'hover:bg-primary-900 hover:text-white'
    ]"
    @click="handleClick"
  >
    <o-icon v-if="hasIcon" :icon="button.icon" :fill="true" :stroke="null" />
    <span v-else class="text-sm">{{ button.name }}</span>
  </button>
</template>

<script setup lang="ts">
import { icons } from '@/components/elements/Icon.vue'
import LinkPopover from './LinkPopover.vue'

interface Props {
  editor: any
  button: any
}

const props = defineProps<Props>()

const disabled = computed(() => {
  const params = props.button.params || {}
  return !props.editor.can().chain().focus()[props.button.command](params).run()
})

const active = computed(() => {
  const params = props.button.params || {}
  return props.button.mark ? props.editor.isActive(props.button.mark, params) : false
})

const params = computed(() => {
  return props.button.params || {}
})

const hasIcon = computed(() => {
  return (icons as any)[props.button.icon]
})

function handleClick () {
  if (props.button.mark === 'placeholder') {
    props.editor.chain().focus().insertContent('{').run()
  } else if (props.button.callback) {
    props.button.callback(props.editor)
  } else {
    handleCommand()
  }
}

function handleCommand () {
  const button = props.button
  const params = button.params || {}

  props.editor
    .chain()
    .focus()[button.command](params)
    .run()
}
</script>
